<template>
    <div>
        <Header title="退款记录"/>
        <div class="scrollerView">
            <scroller
                :on-refresh="refresh"
                :on-infinite="infinite"
                :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <div v-for="(item, index) in dataSources" :key="index">
                    <div class="card">
                        <div>
                            <p>退款状态</p>
                            <span class="status-text">{{item.order_refund_status_text}}</span>
                        </div>
                        <div>
                            <p>退款金额</p>
                            <span>¥ {{item.exact_money}}</span>
                        </div>
                        <div>
                            <p>退款原因</p>
                            <span>{{item.refund_reason}}</span>
                        </div>
                        <div>
                            <p>所属商城</p>
                            <span>{{item.trade_company_name || item.shop_type_text}}</span>
                        </div>
                        <div class="flex rce" v-if="item.refund_status >= 0 && item.refund_status < 50">
                            <p class=""></p>
                            <div class="btn" @click="onPressRevokeRefund(item)">撤销退款</div>
                        </div>
                    </div>
                    <div class="goods">
                        <p>退货商品</p>
                        <div v-for="(_item, _index) in item.order_detail" :key="_index">
                            <img :src="_item.goods_image" alt="">
                            <div>
                                <p class="title">{{_item.goods_name}}</p>
                                <p class="unit">规格:{{_item.sku_field}}</p>
                                <div class="price">
                                    <p>￥{{_item.goods_price}}</p>
                                    <span>×{{_item.num}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="textarea noline">
                            <p>补充描述</p>
                            <textarea rows="3" cols="20" placeholder="请填写补充描述" readonly v-model="item.refund_desc"></textarea>
                        </div>
                    </div>
                    <div class="card" v-if="item.refund_status != 0">
                        <div>
                            <p>退货快递信息：</p>
                            <div class="tap"></div>
                        </div>
                        <div>
                            <p>快递公司：</p>
                            <input type="text" :placeholder="item.refund_status == 10 ?'请输入' : '未填写'" :readonly="item.refund_status != 10" v-model="item.express_name">
                        </div>
                        <div>
                            <p>快递单号：</p>
                            <input type="text" :placeholder="item.refund_status == 10 ?'请输入' : '未填写'" :readonly="item.refund_status != 10" v-model="item.express_no">
                        </div>
                    </div>
                    <div v-if="item.refund_status == 10" class="refundBtn" @click="onPressSubmit(item)">确认物流信息</div>
                </div>
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </scroller>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header'
export default {
    components: {
        'Header': Header,
    },
    data() {
        return {
            loading: false,
            page: 1,
            limit: 10,
            dataSources: [],
            order_id: this.$route.query.order_id || '',
        };
    },
    mounted() {
        this.requestData();
    },
    methods: {
        // -------------------------------------------------- request  --------------------------------------------------
        // 请求数据
        async requestData() {
            let url = this.API.shop_refund_record;
            let params = {
                order_id: this.order_id,
                page: this.page,
                limit: this.limit,
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.data;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                if (this.page === 1) {
                    dataSourcesTemp = dataList
                    this._dataSource = result.data.data;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                this.dataSources = dataSourcesTemp
                this.$refs.infinite.finishInfinite(dataList.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // -------------------------------------------------- mothed  --------------------------------------------------
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // -------------------------------------------------- onPress  --------------------------------------------------
        // 点击跳转
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
        // 提交退款信息
        async onPressSubmit(item) {
            if (item.express_name === '' || item.express_name === null || item.express_no === '' || item.express_no === null) {
                this.Message({
                    title: '请完善物流信息',
                });
                return
            }
            let url = this.API.shop_logistics_info;
            let params = {
                refund_id: item.id,
                order_no: item.order_no,
                express_no: item.express_no,
                express_name: item.express_name,
            };
            let result = await this.$post(url, params);
            this.ToastManager(result.msg);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.refresh();
            }
        },
        // 点击撤销退款
        onPressRevokeRefund(item) {
            this.$dialog.confirm({
                title: '温馨提示',
                message: '您的操作即将取消退款申请！',
            })
            .then(() => {
                this.revokeRefund(item);
            })
            .catch(() => {
                this.Message({
                    title: "已取消"
                });
            });
        },
        // 撤销退款
        async revokeRefund(item) {
            let url = this.API.shop_revoke_refund;
            let params = {
                refund_id: item.id,
            };
            let result = await this.$post(url, params);

            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.refresh()
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
    height: 100vh;
}

.scroller {
    background: #F8F8F8;
}

.type {
    margin: 10px 15px 0;
    padding: 0 15px;
    height: 72px;
    display: flex;
    align-items: center;
    background-image: url('../../assets/img/img_btn_bg1.png');
    background-size: cover;

    > .icon {
        width: 30px;
        height: 30px;
        object-fit: contain;
    }

    > div {
        flex: 1;
        margin: 0 10px;
        display: flex;
        flex-direction: column;

        > p {
            margin-bottom: 5px;
            font-size: 15px;
            color: #fff;
        }

        > span {
            font-size: 13px;
            color: #fff;
        }
    }

    > .arrow {
        width: 8px;
        height: 15px;   
    }
}

.card {
    margin: 10px 15px 0;
    padding: 0 10px;
    background: #fff;

    > div {
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #f3f0ee;
        
        p {
            flex: 1;
            height: 50px;
            font-size: 14px;
            color: #666666;
            line-height: 50px;
        }

        span {
            font-size: 14px;
            color: #333;
        }
        .status-text {
            color: #fff;
            font-size: 1.2rem;
            background: #03a9f4;
            padding: 0.2rem 0.5rem;
            border-radius: 0.5rem 0;
        }

        .btn {
            width: 67px;
            height: 26px;
            background: linear-gradient(205deg,#9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            color: #fff;
        }

        .tap {
            font-size: 13px;
            color: #6472e8;
        }

        input {
            flex: 1;
            text-align: right;
            font-size: 14px;
            color: #333;
        }
    }

    .textarea {
        padding-bottom: 10px;
        flex-direction: column;
        align-items: flex-start;

        textarea {
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            border-width: 0px;
            background: #F8F8F8;
            resize:none;
            font-size: 14px;
            color: #333;
        }
    }

    .noline {
        border-bottom: 0px;
    }
}

.refundBtn {
    height: 45px;
    margin: 1.5rem 1.5rem;
    border-radius: 3px;
    background: linear-gradient(205deg,#9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    border-bottom: 0;
}

.goods {
    margin: 10px 15px 0;
    padding: 0 10px 10px;
    background: #fff;

    > p {
        padding-top: 10px;
        font-size: 14px;
        color: #333;
    }

    > div {
        display: flex;
        margin: 10px 0 0;

        > img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            margin-right: 10px;
        }

        > div {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            overflow: hidden;

            .title {
                font-size: 14px;
                color: #333;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }

            .unit {
                font-size: 12px;
                color: #666666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .price {
                display: flex;
                align-items: center;
                
                p {
                    flex: 1;
                    font-size: 14px;
                    color: #EF1400;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                span {
                    font-size: 13px;
                    color: #333;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>